var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeichern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,12.3207,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.69634,-1.77636e-15,16.9365)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.69634,15.9713,16.9365)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1.81414,1.11084e-16,26.2931,11.9778)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.67394e-17,0.6,-1.07347,6.57308e-17,22.1504,19.6364)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.67394e-17,0.6,-1.07347,6.57308e-17,22.1504,24.1084)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.07153e-17,1,-1.53152,9.36751e-17,22.3177,0.89838)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.054,
    y: 1.235,
    width: 2.053,
    height: 8.716,
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.997181,0,-0.108589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.787,9.607C31.787,9.392 31.613,9.218 31.399,9.218L30.623,9.218C30.409,9.218 30.235,9.392 30.235,9.607L30.235,32.786C30.235,33 30.409,33.175 30.623,33.175L31.399,33.175C31.613,33.175 31.787,33 31.787,32.786L31.787,9.607Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.27246,-30.2353,-9.5406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.787,9.523C31.787,9.354 31.613,9.218 31.399,9.218L30.623,9.218C30.409,9.218 30.235,9.354 30.235,9.523L30.235,32.87C30.235,33.038 30.409,33.175 30.623,33.175L31.399,33.175C31.613,33.175 31.787,33.038 31.787,32.87L31.787,9.523Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.618248,-0.785983,0.108896,0.0856565,-19.6967,55.5312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.787,12.017C31.787,10.472 31.613,9.218 31.399,9.218L30.623,9.218C30.409,9.218 30.235,10.472 30.235,12.017L30.235,30.375C30.235,31.92 30.409,33.175 30.623,33.175L31.399,33.175C31.613,33.175 31.787,31.92 31.787,30.375L31.787,12.017Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.618248,-0.785983,-0.122368,0.0962538,23.7117,24.1405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.787,11.709C31.787,10.334 31.613,9.218 31.399,9.218L30.623,9.218C30.409,9.218 30.235,10.334 30.235,11.709L30.235,30.683C30.235,32.058 30.409,33.175 30.623,33.175L31.399,33.175C31.613,33.175 31.787,32.058 31.787,30.683L31.787,11.709Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.618248,-0.785983,-0.107308,0.0844081,51.5041,55.6995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.787,12.059C31.787,10.491 31.613,9.218 31.399,9.218L30.623,9.218C30.409,9.218 30.235,10.491 30.235,12.059L30.235,30.334C30.235,31.902 30.409,33.175 30.623,33.175L31.399,33.175C31.613,33.175 31.787,31.902 31.787,30.334L31.787,12.059Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.733,33.518C29.733,33.328 29.58,33.175 29.39,33.175L2.56,33.175C2.371,33.175 2.217,33.328 2.217,33.518L2.217,34.204C2.217,34.393 2.371,34.547 2.56,34.547L29.39,34.547C29.58,34.547 29.733,34.393 29.733,34.204L29.733,33.518Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.136897,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.025,0.411C23.025,0.184 22.841,0 22.614,0L3.085,0C2.858,0 2.673,0.184 2.673,0.411L2.673,1.234C2.673,1.462 2.858,1.646 3.085,1.646L22.614,1.646C22.841,1.646 23.025,1.462 23.025,1.234L23.025,0.411Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.476501,0.457086,-0.692252,0.721656,21.0279,-1.19169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.025,0.411C23.025,0.184 22.746,0 22.402,0L3.297,0C2.953,0 2.673,0.184 2.673,0.411L2.673,1.234C2.673,1.462 2.953,1.646 3.297,1.646L22.402,1.646C22.746,1.646 23.025,1.462 23.025,1.234L23.025,0.411Z",
    style: {
      fill: "rgb(235,235,235)"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeichern);
export default __webpack_public_path__ + "static/media/Speichern.a942a0188b83e4a7c179dda2746be73e.svg";
export { ForwardRef as ReactComponent };